import { decode } from 'html-entities'
import { renameKeys } from './object.js'
/*

Rails API responds with objects so we can normalize responses. This leaves the old keys in place, which we can't send to the api.
This function remaps keys so Rails can consume them nicely

  i.e.

  timeline: {
    photos: [1],
  }

  becomes

  timeline: {
    photo_ids: [1]
  }

*/
import { normalize, Schema, arrayOf } from 'normalizr'

export function normalizeAndRemapTimeline(json) {
  return remapNormalized(normalizeTimeline(json))
}

export function normalizeAndRemapMarker(json) {
  return remapNormalized(normalizeMarker(json))
}

export function normalizeAndRemapPhoto(json) {
  return remapNormalized(normalizePhoto(json))
}

export function normalizeAndRemapTimespan(json) {
  return remapNormalized(normalizeTimespan(json))
}

export function remapNormalized(normalized) {
  const { entities } = normalized
  if (entities.timelines) remapTimelineKeys(entities.timelines)
  if (entities.markers) remapMarkerKeys(entities.markers)
  return normalized
}

function normalizeTimeline(json) {
  // define schema
  const timelineSchema = new Schema('timelines')
  const markerSchema = new Schema('markers')
  const timespanSchema = new Schema('timespans')
  const userSchema = new Schema('users')
  const photoSchema = new Schema('photos')
  const categorySchema = new Schema('categories')
  // define nesting rules
  timelineSchema.define({
    timeline: timelineSchema,
    categories: arrayOf(categorySchema),
    photos: arrayOf(photoSchema),
    markers: arrayOf(markerSchema),
    timespans: arrayOf(timespanSchema),
    owner: userSchema,
  })
  markerSchema.define({
    photos: arrayOf(photoSchema),
  })
  const normalized = normalize(json, timelineSchema)
  // first decode any category names we might have
  if (normalized.entities.categories) {
    Object.keys(normalized.entities.categories).forEach(key => {
      normalized.entities.categories[key].name = decode(normalized.entities.categories[key].name)
    })
  }
  return normalized
}

function normalizeMarker(json) {
  const markerSchema = new Schema('markers')
  const photoSchema = new Schema('photos')
  markerSchema.define({
    photos: arrayOf(photoSchema),
  })
  return normalize(json, markerSchema)
}

function normalizeTimespan(json) {
  const timespanSchema = new Schema('timespans')
  return normalize(json, timespanSchema)
}

function normalizePhoto(json) {
  const photoSchema = new Schema('photos')
  return normalize(json, photoSchema)
}

// Helper functions

function remapTimelineKeys(entities) {
  Object.keys(entities).forEach(key => {
    entities[key] = renameKeys(entities[key], [
      ['categories', 'category_ids'],
      ['markers', 'marker_ids'],
      ['timespans', 'timespan_ids'],
      ['photos', 'photo_ids'],
      ['owner', 'owner_id'],
    ])
  })
  return entities
}

function remapMarkerKeys(entities) {
  Object.keys(entities).forEach(key => {
    entities[key] = renameKeys(entities[key], [['photos', 'photo_ids']])
  })
  return entities
}
